import useHalloween from "../hooks/useHalloween";

function HalloweenTheme(props) {
  useHalloween(props);
  return null;
}

export default HalloweenTheme;
